import  { components as Components } from 'react-select'
const CustomOption = ({ children, ...props }) => {
    // eslint-disable-next-line no-unused-vars
    const { onMouseMove, onMouseOver, ...rest } = props.innerProps
    const newProps = { ...props, innerProps: rest }

    return (
        <Components.Option {...newProps} className="custom-option">
            {children}
        </Components.Option>
    )
}

export default CustomOption